// @flow
import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import SlideRightFadeIn from 'shared/transitions/SlideRightFadeIn';
import type { Styles } from 'shared/types';
import isElementInViewport from 'shared/lib/isElementInViewport';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

interface Props {
  children?: React.Node
}

export default function AnimatedTitle(props: Props){
  const c: Styles<typeof styles> = useStyles();
  const [animated, setAnimated] = useState(false);

  const container = useRef();

  // Play animation when element is visible
  useEffect(() => {
    const onScroll = () => {
      if (!animated && isElementInViewport(container.current)) {
        setAnimated(true);
      }
    };

    // Initial call + add to scroll event only if it hasn't animated yet
    if (!animated) {
      onScroll();
      window.addEventListener('scroll', onScroll);
    }

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [animated]);

  return (
    <div ref={container}>
      <SlideRightFadeIn show={animated}>
        <div className={c.pageTitle}>
          {props.children}
        </div>
      </SlideRightFadeIn>
    </div>
  );
}

const styles = {
  pageTitle: {
    fontSize: '40px',
    fontWeight: '300',
    letterSpacing: '1px',
    lineHeight: '1.2em',
    fontFamily: FONT_FAMILY_ROBOTO
  },
};

const useStyles = createUseStyles(styles);
